import { render, staticRenderFns } from "./uppy_invoices.vue?vue&type=template&id=932b1544&scoped=true"
import script from "./uppy_invoices.vue?vue&type=script&lang=js"
export * from "./uppy_invoices.vue?vue&type=script&lang=js"
import style0 from "./uppy_invoices.vue?vue&type=style&index=0&id=932b1544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932b1544",
  null
  
)

export default component.exports